import { Mark, markInputRule, mergeAttributes } from '@tiptap/core';

interface AnswerOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    answer: {
      /**
       * Set a answer mark
       */
      setAnswer: () => ReturnType;
      /**
       * Toggle a answer mark
       */
      toggleAnswer: () => ReturnType;
      /**
       * Unset a answer mark
       */
      unsetAnswer: () => ReturnType;
    };
  }
}

const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/;
const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/;

const answerType = 'answer';

const Answer = Mark.create<AnswerOptions>({
  name: answerType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'answer',
      },
    ];
  },

  addAttributes() {
    return {
      id: {
        default: null,
      },
      style: {
        default: null,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'answer',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setAnswer: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleAnswer: () => ({ commands }) => {
        return commands.toggleMark(this.name);
      },
      unsetAnswer: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      },
    };
  },

  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type,
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { mark: Answer, type: answerType };
